import { API_PATH, fetchFromApi, handleLogout, optionsForPostRequest } from './apiUtils';

export const loginRedirect = () => {
  if (window.location.hostname === 'localhost') {
    const baseUrl = 'http://localhost:8200'
    window.location.href = `${baseUrl}${API_PATH}/oauth2/authorization/keycloak`;
  } else {
    window.location.pathname = `${API_PATH}/oauth2/authorization/keycloak`;
  }
};

export const refreshSession = () => fetchFromApi('/auth/session');

export const logUserOutRequest = async () => {
  return await fetchFromApi(
      `/logout`,
      optionsForPostRequest(),
      handleLogout
  );
};

export const redirectToUserData = language => {
  window.open(`${window.location.origin}/account/?language=${language}`);
};
